module.exports = __webpack_public_path__ + "img/cafeamplatzoeffnungszeitentante.fca1c3db.png";